import CalculateSection from './AdminShowList';
export default CalculateSection;
